import { Container, Icon, Typography } from '@design-system';
import React, { useEffect, useState } from 'react';
import { IoChevronDownSharp } from 'react-icons/io5';
import { LiaArrowLeftSolid } from 'react-icons/lia';
import './ListItem.scss';

export type ListItemProps = {
    title: string;
    tag?: string | null;
    icon: React.ReactNode;
    onClick: () => void;
    customRightIcon?: React.ReactNode;
    date?: string;
    type?: 'default' | 'dropdown';
    dropdownItems?: {
        id: number;
        label: string;
        onClick?: () => void;
    }[];
} & React.HTMLAttributes<HTMLDivElement>;

export const ListItem: React.FC<ListItemProps> = ({
    title,
    tag,
    icon,
    onClick,
    customRightIcon,
    date,
    type = 'default',
    dropdownItems,
    className,
    ...props
}) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isDisabled, setIsDisabled] = useState<boolean>(type === 'dropdown');

    useEffect(() => {
        if (type === 'dropdown') {
            const timer = setTimeout(() => {
                setIsOpen(true);
                setIsDisabled(false);
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [type]);

    if (type === 'default') {
        return (
            <Container
                className={`list-item default ${className}`}
                onClick={onClick}
                bordered="grey"
                padding="medium large"
                flexRow
                {...props}
            >
                <div className="list-item-content">
                    {icon}
                    <div className="list-item-title">
                        {tag && <span className="list-item-tag">{tag}</span>}
                        <Typography intrinsic="h4" className="file-title">
                            {title}
                        </Typography>
                        {date && <Typography intrinsic="p">{new Date(date).toLocaleDateString()}</Typography>}
                    </div>
                </div>
                <div className={`list-item-arrow ${type}`}>
                    {customRightIcon && <>{customRightIcon}</>}
                    {!customRightIcon && (
                        <Icon icon={<LiaArrowLeftSolid />} size={26} color="green" variant="surrounded" bordered className="arrow-icon" />
                    )}
                </div>
            </Container>
        );
    }

    return (
        <>
            <Container
                className={`list-item mb-none ${className}`}
                onClick={() => {
                    if (!isDisabled) {
                        setIsOpen(!isOpen);
                    }
                }}
                bordered="grey"
                padding="medium large"
                flexRow
            >
                <div className="list-item-content">
                    {icon}
                    <Typography intrinsic="h4">{title}</Typography>
                </div>
                <div className={`list-item-arrow list-dropdown ${isOpen ? 'open' : ''}`}>
                    <Icon icon={<IoChevronDownSharp />} size={28} color="green" variant="plain" />
                </div>
            </Container>
            {dropdownItems && (
                <>
                    <div className={`list-item-dropdown ${isOpen ? 'open' : ''}`}>
                        {dropdownItems.map((item, index) => (
                            <Container
                                key={item.id}
                                bordered="grey"
                                padding="medium-large-spacing large-spacing"
                                flexRow
                                className={`dropdown-item ${isOpen ? 'visible' : 'closing'}`}
                                onClick={() => item?.onClick?.()}
                            >
                                <Typography key={item.id} intrinsic="h4" style={{ animationDelay: `${index * 100}ms` }}>
                                    {item.label}
                                </Typography>
                            </Container>
                        ))}
                    </div>
                </>
            )}
        </>
    );
};
